(function () {
  'use strict';
  var E = window.ELVI = window.ELVI || {};
  var sec = document.querySelector('[data-elvi]');
  if (!sec) return;
  E.currency = sec.getAttribute('data-currency') || 'GBP';
  var gal = sec.querySelector('[data-elvi-gallery]');
  var filtersEl = sec.querySelector('[data-elvi-filters]');
  var gridEl = sec.querySelector('[data-elvi-grid]');
  var countEl = sec.querySelector('[data-elvi-count]');
  var sentinel = sec.querySelector('[data-elvi-sentinel]');
  var quizEl = sec.querySelector('[data-elvi-quiz]');
  var css = document.createElement('style');
  css.textContent = '@media(max-width:600px){.elvi-scope .elvi-grid{column-count:1}}';
  document.head.appendChild(css);
  var f = { type: 'all', room: 'all', mood: 'all' };
  var shown = 0, list = [], STEP = 20, io = null;

  function groups() {
    return [['type', 'Type', E.types], ['room', 'Room', E.rooms], ['mood', 'Mood', E.moods]];
  }
  function match(p) {
    return (f.type === 'all' || p.g === f.type) && (f.room === 'all' || p.rooms.indexOf(f.room) > -1) &&
      (f.mood === 'all' || p.moods.indexOf(f.mood) > -1);
  }
  function usable(key, val) {
    return (E.products || []).some(function (p) {
      return key === 'type' ? p.g === val : key === 'room' ? p.rooms.indexOf(val) > -1 : p.moods.indexOf(val) > -1;
    });
  }

  function renderFilters() {
    var h = '';
    groups().forEach(function (g) {
      h += '<div class="elvi-frow"><span class="elvi-flabel">' + g[1] + '</span><button type="button" class="elvi-chip" data-k="' + g[0] + '" data-v="all" aria-pressed="' + (f[g[0]] === 'all') + '">All</button>';
      g[2].forEach(function (o) {
        if (!usable(g[0], o[0])) return;
        h += '<button type="button" class="elvi-chip" data-k="' + g[0] + '" data-v="' + o[0] + '" aria-pressed="' + (f[g[0]] === o[0]) + '">' + o[1] + '</button>';
      });
      h += '</div>';
    });
    filtersEl.innerHTML = h;
  }

  E.setFilters = function (patch) {
    Object.keys(patch).forEach(function (k) { f[k] = patch[k]; });
    E.load().then(function () { renderFilters(); renderGrid(); });
  };

  function observe() {
    if (!('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        if (x.target === sentinel) { more(); } else { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px 160px 0px' });
  }

  /* Photo filter: skip photos with a plain light background (grey packshots, size diagrams) */
  var plainCache = {};
  function plain(src) {
    if (plainCache[src]) return plainCache[src];
    return plainCache[src] = new Promise(function (res) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var N = 40, c = document.createElement('canvas');
          c.width = N; c.height = N;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, N, N);
          var d = x.getImageData(0, 0, N, N).data, tot = 0, ok = 0, i, j, k, r, g, b, mx, mn;
          for (j = 0; j < N; j++) for (i = 0; i < N; i++) {
            if (j > 1 && j < N - 2 && i > 1 && i < N - 2) continue;
            k = (j * N + i) * 4; r = d[k]; g = d[k + 1]; b = d[k + 2];
            mx = Math.max(r, g, b); mn = Math.min(r, g, b);
            tot++;
            if (mn >= 222 && mx - mn <= 22) ok++;
          }
          res(ok / tot >= 0.88);
        } catch (e) { res(false); }
      };
      im.onerror = function () { res(false); };
      im.src = E.img(src, 160);
    });
  }
  /* Only the first photos of a product are used on the cards: the last ones are usually size diagrams or close-ups */
  function cands(p) {
    var n = p.images.length, k = n >= 6 ? 3 : (n >= 3 ? 2 : 1), a = [], i;
    for (i = 0; i < k; i++) a.push(i);
    return a;
  }
  function order(p) {
    return cands(p).sort(function (m, n) { return E.hash(p.handle + 'o' + m) - E.hash(p.handle + 'o' + n); });
  }
  function pick(p) {
    if (p._pick) return p._pick;
    var o = order(p), n = 0;
    function next() {
      if (n >= o.length) { p._cover = cands(p)[0]; return p._cover; }
      var i = o[n++];
      return plain(p.images[i].src).then(function (pl) { if (!pl) { p._cover = i; return i; } return next(); });
    }
    return p._pick = Promise.resolve(next());
  }
  function good(p) {
    if (p._good) return p._good;
    return p._good = Promise.all(cands(p).map(function (i) {
      return plain(p.images[i].src).then(function (pl) { return pl ? -1 : i; });
    })).then(function (a) { return a.filter(function (i) { return i >= 0; }); });
  }
  var baseCover = E.cover;
  E.cover = function (p) { return p._cover >= 0 ? p._cover : baseCover(p); };

  function cardHtml(p) {
    var c = p.images[p._cover];
    return '<button type="button" class="elvi-card" data-h="' + E.esc(p.handle) + '"><span class="elvi-card__media" style="aspect-ratio:' + c.w + '/' + c.h + '">' +
      '<img class="is-on" src="' + E.esc(E.img(c.src, 640)) + '" srcset="' + E.esc(E.img(c.src, 420)) + ' 420w, ' + E.esc(E.img(c.src, 700)) + ' 700w, ' + E.esc(E.img(c.src, 1000)) + ' 1000w" sizes="(min-width:1100px) 22vw, (min-width:700px) 31vw, 92vw" alt="' + E.esc(p.title) + '" loading="lazy">' +
      '<img src="" alt="" aria-hidden="true"><span class="elvi-card__qv">Quick view</span></span>' +
      '<span class="elvi-card__name">' + E.esc(p.title) + '</span><span class="elvi-card__price">' + (p.from ? 'From ' : '') + E.money(p.price) +
      (p.compare ? ' <s>' + E.money(p.compare) + '</s>' : '') + '</span></button>';
  }

  var gen = 0, busy = false, kept = 0;
  function countText() {
    countEl.textContent = kept ? kept + (kept === 1 ? ' piece' : ' pieces') : 'No piece matches these filters yet. Try another mood or room.';
  }
  function more() {
    if (busy || shown >= list.length) return;
    busy = true;
    var my = gen, batch = list.slice(shown, shown + STEP);
    shown = Math.min(list.length, shown + STEP);
    Promise.all(batch.map(pick)).then(function () {
      if (my !== gen) return;
      var html = '';
      batch.forEach(function (p) {
        if (p._cover >= 0) html += cardHtml(p); else kept--;
      });
      countText();
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      while (tmp.firstChild) {
        var el = tmp.firstChild;
        gridEl.appendChild(el);
        if (io) io.observe(el); else el.classList.add('is-in');
      }
      busy = false;
      if (io && sentinel) { io.unobserve(sentinel); io.observe(sentinel); }
    });
  }

  function renderGrid() {
    observe();
    gen++; busy = false;
    list = (E.products || []).filter(match).sort(function (a, b) { return E.hash(a.handle + 'x') - E.hash(b.handle + 'x'); });
    gridEl.innerHTML = ''; shown = 0; kept = list.length;
    countText();
    more();
    if (io && sentinel) { io.unobserve(sentinel); io.observe(sentinel); }
  }

  filtersEl.addEventListener('click', function (e) {
    var b = e.target.closest('.elvi-chip');
    if (!b) return;
    f[b.getAttribute('data-k')] = b.getAttribute('data-v');
    renderFilters(); renderGrid();
  });

  /* Hover: cycle through the other nice photos of the product */
  var cyc = null;
  function swap(card, idx, p) {
    var imgs = card.querySelectorAll('img'), on = card.querySelector('img.is-on'), off = on === imgs[0] ? imgs[1] : imgs[0];
    var src = E.img(p.images[idx].src, 700), t = new Image();
    t.onload = function () { off.src = src; off.classList.add('is-on'); on.classList.remove('is-on'); };
    t.src = src;
  }
  gridEl.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var card = e.target.closest('.elvi-card');
    if (!card || card === cyc) return;
    var p = (E.products || []).filter(function (x) { return x.handle === card.getAttribute('data-h'); })[0];
    if (!p || p.images.length < 2) return;
    clear();
    cyc = card;
    good(p).then(function (g) {
      if (cyc !== card || g.length < 2) return;
      var pos = Math.max(0, g.indexOf(E.cover(p)));
      function step() { pos = (pos + 1) % g.length; swap(card, g[pos], p); }
      card._t = setInterval(step, 1300);
      step();
    });
  });
  function clear() {
    if (!cyc) return;
    clearInterval(cyc._t);
    var h = cyc.getAttribute('data-h'), p = (E.products || []).filter(function (x) { return x.handle === h; })[0];
    if (p) swap(cyc, E.cover(p), p);
    cyc = null;
  }
  gridEl.addEventListener('pointerout', function (e) {
    var card = e.target.closest('.elvi-card');
    if (card && card === cyc && !card.contains(e.relatedTarget)) clear();
  });
  gridEl.addEventListener('click', function (e) {
    var card = e.target.closest('.elvi-card');
    if (!card) return;
    var p = (E.products || []).filter(function (x) { return x.handle === card.getAttribute('data-h'); })[0];
    if (p) E.open(p, E.cover(p));
  });

  /* Quick view */
  var modal = null, cur = null, idx = 0, vsel = null, lastFocus = null;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'elvi-modal elvi-scope';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Product preview');
    modal.innerHTML = '<div class="elvi-modal__bg" data-close></div><div class="elvi-modal__box"><button type="button" class="elvi-modal__x" data-close aria-label="Close">×</button>' +
      '<div class="elvi-modal__gal"><div class="elvi-modal__main"><img data-main alt=""><button type="button" class="elvi-nav elvi-nav--prev" data-prev aria-label="Previous photo">‹</button><button type="button" class="elvi-nav elvi-nav--next" data-next aria-label="Next photo">›</button><span class="elvi-modal__n" data-n></span></div><div class="elvi-modal__thumbs" data-thumbs></div></div>' +
      '<div class="elvi-modal__info"><p class="elvi-modal__kind" data-kind></p><h2 class="elvi-modal__title" data-title></h2><p class="elvi-modal__price" data-price></p>' +
      '<label class="elvi-modal__var" data-vwrap hidden><span>Option</span><select data-variant></select></label>' +
      '<button type="button" class="elvi-btn elvi-btn--solid elvi-add" data-add>Add to cart</button><p class="elvi-modal__msg" data-msg role="status"></p><a class="elvi-link" data-link href="#">View full details</a></div></div>';
    document.body.appendChild(modal);
    vsel = modal.querySelector('[data-variant]');
    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-close]')) close();
      else if (t.closest('[data-prev]')) show(idx - 1);
      else if (t.closest('[data-next]')) show(idx + 1);
      else if (t.closest('[data-t]')) show(parseInt(t.closest('[data-t]').getAttribute('data-t'), 10));
      else if (t.closest('[data-add]')) add();
    });
    vsel.addEventListener('change', function () {
      var v = variant();
      if (v && v.img) {
        var base = v.img.split('?')[0];
        cur.images.forEach(function (im, i) { if (im.src.split('?')[0] === base) show(i); });
      }
      priceUpdate();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  }
  function variant() { var id = parseInt(vsel.value, 10); return cur.variants.filter(function (v) { return v.id === id; })[0]; }
  function priceUpdate() {
    var v = variant(), el = modal.querySelector('[data-price]'), b = modal.querySelector('[data-add]');
    el.innerHTML = E.money(v.price) + (v.compare > v.price ? ' <s>' + E.money(v.compare) + '</s>' : '');
    b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out';
    modal.querySelector('[data-msg]').innerHTML = '';
  }
  function show(i) {
    var n = cur.images.length;
    idx = (i + n) % n;
    var im = cur.images[idx], main = modal.querySelector('[data-main]');
    main.style.opacity = 0;
    setTimeout(function () { main.src = E.img(im.src, 1100); main.alt = cur.title; main.onload = function () { main.style.opacity = 1; }; }, 120);
    modal.querySelector('[data-n]').textContent = n > 1 ? (idx + 1) + ' / ' + n : '';
    [].forEach.call(modal.querySelectorAll('[data-t]'), function (t) { t.setAttribute('aria-current', parseInt(t.getAttribute('data-t'), 10) === idx ? 'true' : 'false'); });
    var arrows = n > 1 ? '' : 'none';
    modal.querySelector('[data-prev]').style.display = arrows; modal.querySelector('[data-next]').style.display = arrows;
  }
  E.open = function (p, start) {
    if (!modal) buildModal();
    cur = p; lastFocus = document.activeElement;
    var kind = (E.types.filter(function (t) { return t[0] === p.g; })[0] || [0, ''])[1];
    modal.querySelector('[data-kind]').textContent = kind;
    modal.querySelector('[data-title]').textContent = p.title;
    modal.querySelector('[data-link]').href = p.url;
    modal.querySelector('[data-thumbs]').innerHTML = p.images.map(function (im, i) {
      return '<button type="button" data-t="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + E.esc(E.img(im.src, 140)) + '" alt="" loading="lazy"></button>';
    }).join('');
    var multi = p.variants.length > 1 && p.variants[0].title !== 'Default Title';
    modal.querySelector('[data-vwrap]').hidden = !multi;
    vsel.innerHTML = p.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + E.esc(v.title) + ' – ' + E.money(v.price) + '</option>';
    }).join('');
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    vsel.value = String(first.id);
    priceUpdate();
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    show(start || 0);
    modal.querySelector('.elvi-modal__x').focus();
  };
  function close() {
    modal.classList.remove('is-open');
    setTimeout(function () { modal.hidden = true; }, 250);
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function add() {
    var v = variant(), b = modal.querySelector('[data-add]'), m = modal.querySelector('[data-msg]');
    if (!v || !v.available) return;
    b.disabled = true; m.textContent = 'Adding to your cart...';
    fetch(E.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).then(function () {
      b.textContent = 'Added to your cart'; b.disabled = false;
      m.innerHTML = '<a href="' + E.root + 'cart">View your cart</a>';
    }).catch(function () { b.disabled = false; m.textContent = 'Sorry, that could not be added. Please try again.'; });
  }

  /* Start */
  var qs = new URLSearchParams(window.location.search);
  ['type', 'room', 'mood'].forEach(function (k) { if (qs.get(k)) f[k] = qs.get(k); });
  if (quizEl) E.initQuiz(quizEl);
  E.load().then(function () { renderFilters(); renderGrid(); }).catch(function () {
    countEl.innerHTML = 'We could not load the collection just now. <a href="' + E.root + 'collections/all">Browse every piece</a>.';
  });
})();